export enum ChatSessionType {
  Private = 1,
  PrivatePromotional = 4,
}
